import '../styles/Landing.css';
import Flower from '../components/common/Flower/Flower';
import ClickFlower from '../components/common/ClickFlower/ClickFlower';
import { useNavigate } from "react-router-dom";
import ProjectHeader from '../components/common/ProjectHeader/ProjectHeader';

export default function Landing() {
  const nav = useNavigate();

  return (
    <div className='App'>
      <ProjectHeader
      headerTitle={"Witaj"}/>
      <div className='LandingPage'> 
        <button onClick={() => nav('/local')} className='LandingButtons btn-style'> Pracuj bez konta </button>
        <br />
        <button onClick={() => nav('/login')} className='LandingButtons btn-style'> Zaloguj się </button>   
      </div>
      <Flower
      flowerClass={"flower1"}/>
      <Flower
      flowerClass={"flower2"}/>
      <ClickFlower/>
      
      <br/> 
    </div>
  );
}